const DISABLEABLE_SELECTOR =
  "input[data-disable-with], button[data-disable-with], input[data-disable], button[data-disable]";

const disabledElements = new Map();

function confirmationMessage(form, submitter) {
  return submitter?.dataset.confirm || form.dataset.confirm;
}

// Turbo disables the submitter itself before announcing the submission, so it is let through here to get its
// replacement content.
function disableableElements(form, submitter) {
  return Array.from(form.elements).filter(
    (element) =>
      element.matches(DISABLEABLE_SELECTOR) &&
      !disabledElements.has(element) &&
      (!element.disabled || element === submitter)
  );
}

function disableElement(element) {
  const replacement = element.dataset.disableWith;
  const isInput = element.matches("input");
  disabledElements.set(element, isInput ? element.value : element.innerHTML);

  if (replacement !== undefined) {
    if (isInput) {
      element.value = replacement;
    } else {
      element.innerHTML = replacement;
    }
  }
  element.disabled = true;
}

function enableElement(element) {
  const original = disabledElements.get(element);
  disabledElements.delete(element);

  if (element.dataset.disableWith !== undefined) {
    if (element.matches("input")) {
      element.value = original;
    } else {
      element.innerHTML = original;
    }
  }
  element.disabled = false;
}

function disableForm(form, submitter) {
  disableableElements(form, submitter).forEach(disableElement);
}

function enableForm(form) {
  disabledElements.forEach((_original, element) => {
    if (element.form === form) {
      enableElement(element);
    }
  });
}

function enableAll() {
  disabledElements.forEach((_original, element) => enableElement(element));
}

function handleSubmit(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) {
    return;
  }

  const message = confirmationMessage(form, event.submitter);
  if (message && !window.confirm(message)) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }

  // Disabling a submitter before the browser builds the form data would drop its name and value from the request,
  // so wait for the event to finish. A prevented submit is either cancelled or taken over by Turbo, whose own
  // events disable the form below.
  window.setTimeout(() => {
    if (!event.defaultPrevented) {
      disableForm(form);
    }
  }, 0);
}

export function startFormSubmitBehaviours() {
  document.addEventListener("submit", handleSubmit, true);
  document.addEventListener("turbo:submit-start", (event) =>
    disableForm(event.target, event.detail.formSubmission.submitter)
  );
  document.addEventListener("turbo:submit-end", (event) =>
    enableForm(event.target)
  );
  // A page restored from the back-forward cache keeps the disabled buttons it was left with.
  window.addEventListener("pageshow", enableAll);
}
